import React, { useState } from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, Checkbox, ListItemText, Button, TextField, InputAdornment } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const initialTasks = [
  { text: 'Remove Admin-ui', completed: false },
  { text: 'Example: Add your first to-do item!', completed: false },
];

export default function ToDoList() {
  const [tasks, setTasks] = useState(initialTasks);
  const [newTask, setNewTask] = useState("");
  const navigate = useNavigate();

  const handleToggle = idx => {
    setTasks(tasks.map((task, i) => i === idx ? { ...task, completed: !task.completed } : task));
  };

  const handleAddTask = () => {
    const trimmed = newTask.trim();
    if (trimmed.length === 0) return;
    setTasks([...tasks, { text: trimmed, completed: false }]);
    setNewTask("");
  };

  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleAddTask();
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        To Do List
      </Typography>
      <Button variant="contained" onClick={() => navigate(-1)} sx={{ mb: 2 }}>
        Back to Perform Maintenance
      </Button>
      <Box sx={{ display: 'flex', mb: 2, gap: 1 }}>
        <TextField
          label="New To-Do Item"
          value={newTask}
          onChange={e => setNewTask(e.target.value)}
          onKeyDown={handleInputKeyDown}
          size="small"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button
                  variant="contained"
                  onClick={handleAddTask}
                  disabled={newTask.trim().length === 0}
                  sx={{ minWidth: 80 }}
                >
                  Add
                </Button>
              </InputAdornment>
            )
          }}
        />
      </Box>
      <List>
        {tasks.filter(task => !task.completed).map((task, idx) => (
          <ListItem key={idx} disablePadding>
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={task.completed}
                onChange={() => handleToggle(tasks.findIndex(t => t === task))}
              />
            </ListItemIcon>
            <ListItemText
              primary={task.text}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
